import { Box, FormControl, Input, InputLabel, MenuItem, Select } from '@material-ui/core';
import * as React from 'react';
import { useLocation } from 'react-router';
import { NegotiationState, useGetOutDebtsQuery } from '../../generated/graphql';
import { getServerURLBase } from '../../utils/getServerURLBase';
import Btn from '../Btn/Btn';
import Separator from '../Separator/Separator';
import { useNegotiationTestOverrideContext } from './NegotiationTestOverrideContext';

const NegotiationTestOverrideForm: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const {
    negTestOverrideActive,
    negStateTest, setNegStateTest,
    prePaymentTest, setPrePaymentTest,
  } = useNegotiationTestOverrideContext();

  const handleStateChange = (ev: any) => {
    setNegStateTest(ev.target.value);
    onClose();
  };

  const handlePrePaymentChange = (ev: any) => {
    setPrePaymentTest(parseInt(ev.target.value, 10) || 0);
  };

  const options = Object.entries(NegotiationState).map(([ key, value ]) => ({ key, value }));

  const { pathname } = useLocation();
  const debtId = pathname.replace(/^\/portal\/deuda\//, '').replace(/\/.*$/, '');
  const { data: debtsData, refetch: debtsRefetch } = useGetOutDebtsQuery();
  const { negotiation } = debtsData?.outDebts.find((d) => d.id === debtId) ?? {};

  const handleCancelNegotiation = async () => {
    await fetch(`${getServerURLBase()}/api/negotiations/${negotiation?.id}`, { method: 'DELETE' });
    debtsRefetch();
    onClose();
  };

  if (!negTestOverrideActive) return null;
  return (
    <Box
      bgcolor="white"
      p={2}
      display="flex"
      flexDirection="column"
    >
      <FormControl>
        <InputLabel>
          Sobreescribir estado
        </InputLabel>
        <Select
          value={negStateTest}
          onChange={handleStateChange}
        >
          {options.map(({ key, value }) => (
            <MenuItem key={key} value={value}>{value}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <Separator />
      <FormControl>
        <InputLabel>
          Sobreescribir abono
        </InputLabel>
        <Input
          value={prePaymentTest}
          onChange={handlePrePaymentChange}
          placeholder="Valor abono"
        />
      </FormControl>
      <Separator />
      {negotiation && (
      <Btn color="secondary" onClick={handleCancelNegotiation}>
        Cancelar negociación
      </Btn>
      )}
    </Box>
  );
};

export default NegotiationTestOverrideForm;
